import React from 'react';
import Section from '@app/ui/Section/Section';
import HeaderSection from '@app/features/academy/main/HeaderSection/HeaderSection';
import MainSection from '@app/features/academy/main/MainSection/MainSection';
import PromotionCourseSection from '@app/features/academy/main/FooterSection/PromotionCourseSection/PromotionCourseSection';
import {
    IAchievementItemApiModel,
    ICourseInformationApiModel,
    IPromotionCourseApiModel,
} from '@app/models/features/course';
import styles from './page.module.scss';

export interface IProps {
    /**
    * Список ачивок
    */
    achievements: IAchievementItemApiModel[];
    /**
    * Список всех курсов
    */
   courses: ICourseInformationApiModel[];
    /**
     * Информация о рекламном курсе
     */
    promotionCourse: IPromotionCourseApiModel;
}

/**
 * Страница академии пользователя
 */
const AuthorizedMainPage = (props: IProps) => (
    <>
        <Section className={styles['page']} filled={false} animation={false}>
            <div>
                <HeaderSection
                    courses={props.courses}
                    achievements={props.achievements}
                />
            </div>
        </Section>
        <MainSection
            courses={props.courses}
            achievements={props.achievements}
        />
        <Section animation={false}>
            <PromotionCourseSection promotionCourse={props.promotionCourse} />
        </Section>
    </>
);

export default AuthorizedMainPage;
